import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { cloneDeep, sortBy } from 'lodash';

import AddEntityActionButtons from '../../forms/AddEntityActionButtons';
import { ApiServiceServerless } from '../../../xhr_libs';

export default function LinkCustomPlugTemplateModel(props) {
  const {
    show,
    onHide,
    organizationId,
    utility_account_id,
    templates,
    setLocalUtilityAccounts,
    showToast,
  } = props;

  const [templateId, setTemplateId] = useState('');

  const [isSaving, setIsSaving] = useState(false);

  const clearForm = () => {
    setTemplateId('');
  };

  useEffect(() => {
    if (show) {
      clearForm();
    }
  }, [show]);

  const handleSubmit = (e) => {
    setIsSaving(true);
    e.preventDefault();
    addAccountTemplate(templateId);
  };

  const addAccountTemplate = (template_id) => {
    ApiServiceServerless.post(
      `/custom_templates/account/${utility_account_id}`,
      {
        template_id: template_id,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setLocalUtilityAccounts((prev) =>
          prev.map((acc) => {
            if (acc.id !== utility_account_id) return acc;
            let new_acc = cloneDeep(acc);
            new_acc['utility_template'] = res.data;
            return new_acc;
          })
        );

        showToast('success', 'Success', 'Template added to account');
        onHide();
        clearForm();
        setIsSaving(false);
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        onHide();
        setIsSaving(false);
        throw err;
      });
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton style={{ height: '50px' }}>
          {'Add Template to Utility Account'}
        </Modal.Header>
        <Form
          noValidate
          onSubmit={handleSubmit}
          style={{
            textAlign: 'left',
          }}
        >
          <Modal.Body>
            <Row>
              <Col sm={12}>
                <Form.Group>
                  <Form.Label>Template </Form.Label>
                  <Form.Control
                    as='select'
                    onChange={(e) => setTemplateId(parseInt(e.target.value))}
                  >
                    <option key={'null-val'} value={''} hidden></option>
                    {templates.filter(
                      (template) => template.template_type === 'plug'
                    ).length === 0 && (
                      <option key={'null-null'} value={''} disabled>
                        No available templates
                      </option>
                    )}
                    {sortBy(
                      templates.filter(
                        (template) => template.template_type === 'plug'
                      ),
                      ['name']
                    ).map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <AddEntityActionButtons
              onCancel={onHide}
              submitDisabled={templateId === null || templateId === ''}
              submitShow={true}
              isSubmitting={isSaving}
            />
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
